import { BUTTON_HEIGHT, FONT_SIZE, TEXT_SCALE_PROPS } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import styled from "styled-components";

export const Styles = styled.div<
  TEXT_SCALE_PROPS & { isNameRequiredError?: boolean }
>`
  background-color: #fff;
  .container {
    display: flex;

    .left-box,
    .right-box {
      flex: 1;
      margin: 32px 0;
      padding: 0 32px;
    }

    .left-box {
      border-right: 1px solid rgba(0, 0, 0, 0.25);
    }
  }

  .icon-required {
    color: rgba(255, 77, 79, 1);
    margin-right: 4px;
  }

  .no-mb {
    margin-bottom: 0;
  }

  .ant-upload.ant-upload-select-picture-card {
    width: 80px;
    height: 80px;
    span {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
    }
  }

  .wrap-picture {
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-bottom: 8px;
    border-radius: 4px;
    overflow: hidden;

    .wrap-icon-delete {
      position: absolute;
      background-color: rgba(0, 0, 0, 0.55);
      right: 4px;
      top: 4px;
      width: 24px;
      height: 24px;
      border-radius: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }

  .wrap-thumbnail-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    .upload-thumbnail {
      width: 180px;

      .ant-upload.ant-upload-select-picture-card {
        width: 180px;
        border-radius: 8px;
      }
    }

    .wrap-thumbnail-item {
      position: relative;

      .thumbnail-item {
        width: 180px;
        height: 78px;
        gap: 8px;
        border-radius: 8px;
      }

      .wrap-icon-delete {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.55);
        right: 4px;
        top: 4px;
        width: 24px;
        height: 24px;
        border-radius: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
    }
  }

  .wrap-color-picker {
    display: flex;
    width: 200px;
    flex-wrap: wrap;
    gap: 8px;

    .color-picker-item {
      padding: 4px;
      cursor: pointer;

      &.active {
        padding: 2px;
        border-radius: 50%;
        border: 2px solid rgba(0, 0, 0, 0.25);
      }

      .color-picker-background {
        border-radius: 50%;
        width: 24px;
        height: 24px;
      }
    }
  }

  .wrap-list-icon-app {
    display: flex;
    flex-wrap: wrap;
    margin-top: 4px;
    margin-bottom: 4px;

    img {
      width: 56px;
      height: 56px;
      cursor: pointer;

      &.disable {
        opacity: 0.6;
        pointer-events: none;
      }
    }
  }

  .upload-description {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 8px;
  }

  .wrap-icon-app {
    height: 32px;
    padding: 4px;
    border: 1px solid #d9d9d9;
    min-width: 200px;
    margin-left: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.disable {
      opacity: 0.6;
      pointer-events: none;
    }

    span {
      margin-left: 4px;
      color: #1890ff;
    }

    .icon-app {
      height: 24px;
    }
  }

  .icon-delete {
    cursor: pointer;
    margin-left: 8px;
    display: flex;
    align-items: end;
  }

  .ant-input-disabled {
    background-color: #f5f5f5 !important;
  }

  .wrap-background-color-picked {
    border-radius: 4px;
    width: 16px;
    height: 16px;
    border: 1px solid;
    padding: 1px;
    margin-top: 4px;
    margin-left: 8px;

    .background-color-picked {
      border-radius: 4px;
      width: 12px;
      height: 12px;
    }
  }
  .ant-form-item-label label,
  .common-font-size,
  .ant-select-item-option-content,
  .ant-select-selection-item {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]} !important;
  }
  input,
  .ant-picker {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]} !important;
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
    padding: 0px 10px;
  }
  .ant-radio,
  .ant-radio-wrapper,
  .upload-description,
  .ant-form-item-label label {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]} !important;
  }
  .ant-radio-inner {
    height: ${({ text_scale }) =>
      `${
        BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL] -
        (text_scale === DISPLAY_SIZES.LARGE
          ? 12
          : text_scale === DISPLAY_SIZES.MEDIUM
          ? 4
          : 2)
      }px`} !important;

    width: ${({ text_scale }) =>
      `${
        BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL] -
        (text_scale === DISPLAY_SIZES.LARGE
          ? 12
          : text_scale === DISPLAY_SIZES.MEDIUM
          ? 4
          : 2)
      }px`} !important;
  }
  .wrap-list-icon-app img {
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
    width: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
  }
  .wrap-icon-app span,
  .ant-upload.ant-upload-select-picture-card span,
  .ant-form,
  .ant-form-item-explain-error {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]} !important;
  }
  .wrap-thumbnail-list .wrap-thumbnail-item .wrap-icon-delete {
    bottom: 0px !important;
    top: unset;
  }
  .ant-form-vertical .ant-form-item-label {
    padding: 0px;
  }
  ant-input-affix-wrapper {
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
  }
  .ant-input-affix-wrapper {
    padding: 0px 20px !important;
  }
  .ant-form-item {
    padding: ${({ text_scale, isNameRequiredError }) =>
      isNameRequiredError
        ? text_scale === DISPLAY_SIZES.SMALL
          ? "0 0 0px"
          : text_scale === DISPLAY_SIZES.MEDIUM
          ? "0 0 0px"
          : "0 0 0px"
        : "0 0 10px"} !important;
    margin-bottom: 0px;
  }
`;
